import _keyBy from 'lodash/keyBy';
import format from 'date-fns/format';

import {
  getServiceProviderUnavailabilities,
  createServiceProviderUnavailability,
  updateServiceProviderUnavailability,
  deleteServiceProviderUnavailability,

} from '@homeservices/api-kit/serviceprovider';
import {
  createServiceProviderOccupationUnavailability,
  deleteServiceProviderOccupationUnavailability,
  getServiceProviderOccupationUnavailabilities,
  updateServiceProviderOccupationUnavailability,

} from '@homeservices/api-kit/serviceprovider/unavailabilities';


export function activeFilter (unavailability) {
  return unavailability && unavailability.lifecycle_status === 'active';
}

export default {
  state () {
    return {
      rawUnavailabilities: {},
      rawOccupationUnavailabilities: {},
    };
  },
  getters: {
    unavailabilities ({ rawUnavailabilities }) {
      return Object.values(rawUnavailabilities).map(unavailability => ({
        id: unavailability.id,
        startDate: unavailability.unavailability_period_range.start_date,
        endDate: unavailability.unavailability_period_range.end_date,
        type: unavailability.unavailability_period_type,
        lifecycle_status: unavailability.lifecycle_status,
        createdDTM: unavailability.created_dtm,
        modifiedDTM: unavailability.modified_dtm,
      }));
    },
    occupationUnavailabilities ({ rawOccupationUnavailabilities }) {
      return Object.values(rawOccupationUnavailabilities).map(unavailability => ({
        id: unavailability.id,
        startDate: unavailability.unavailability_period_range.start_date,
        endDate: unavailability.unavailability_period_range.end_date,
        type: unavailability.unavailability_period_type,
        lifecycle_status: unavailability.lifecycle_status,
        serviceProviderOccupationId: unavailability.service_provider_occupation_id,
        createdDTM: unavailability.created_dtm,
        modifiedDTM: unavailability.modified_dtm,
      }));
    },
  },
  actions: {
    async fetchServiceProviderUnavailabilities (
      { commit, getters },
      { ids = getters.serviceProvidersIds, ...params } = {}
    ) {
      const { data } = await getServiceProviderUnavailabilities({
        service_provider_ids: ids.join(','),
        min_end_date: format(new Date(), 'yyyy-MM-dd'),
        ...params,
      });
      commit('setServiceProviderUnavailabilities', _keyBy(data.results, 'id'));
    },
    async updateServiceProviderUnavailability (
      { dispatch },
      { unavailabilityId, params }
    ) {
      await updateServiceProviderUnavailability(unavailabilityId, params);
      return dispatch('fetchServiceProviderUnavailabilities');
    },
    async createServiceProviderUnavailability (
      { dispatch },
      { serviceProviderId, params }
    ) {
      await createServiceProviderUnavailability(serviceProviderId, params);
      return dispatch('fetchServiceProviderUnavailabilities');
    },
    async deleteServiceProviderUnavailability (
      { dispatch },
      { unavailabilityId }
    ) {
      await deleteServiceProviderUnavailability(unavailabilityId);
      return dispatch('fetchServiceProviderUnavailabilities');
    },
    async fetchServiceProviderOccupationUnavailabilities (
      { commit },
      params
    ) {
      const { data } = await getServiceProviderOccupationUnavailabilities({
        min_end_date: format(new Date(), 'yyyy-MM-dd'),
        ...params,
      });
      commit('setServiceProviderOccupationUnavailabilities', _keyBy(data.results, 'id'));
    },
    async updateServiceProviderOccupationUnavailability (
      { dispatch, getters },
      { unavailabilityId, params }
    ) {
      const ids = Object.keys(getters.serviceProviderCatalogOccupations).join(',');
      await updateServiceProviderOccupationUnavailability(unavailabilityId, params);
      return dispatch('fetchServiceProviderOccupationUnavailabilities', { service_provider_occupation_ids: ids });
    },
    async createServiceProviderOccupationUnavailability (
      { dispatch, getters },
      { serviceProviderOccupationId, params }
    ) {
      const ids = Object.keys(getters.serviceProviderCatalogOccupations).join(',');
      await createServiceProviderOccupationUnavailability(serviceProviderOccupationId, params);
      return dispatch('fetchServiceProviderOccupationUnavailabilities', { service_provider_occupation_ids: ids });
    },
    async deleteServiceProviderOccupationUnavailability (
      { dispatch, getters },
      { unavailabilityId }
    ) {
      const ids = Object.keys(getters.serviceProviderCatalogOccupations).join(',');
      await deleteServiceProviderOccupationUnavailability(unavailabilityId);
      return dispatch('fetchServiceProviderOccupationUnavailabilities', { service_provider_occupation_ids: ids });
    },
    resetUnavailabilities ({ commit }) {
      commit('resetUnavailabilities');
    },
  },
  mutations: {
    setServiceProviderUnavailabilities (state, data) {
      state.rawUnavailabilities = data;
    },
    setServiceProviderOccupationUnavailabilities (state, data) {
      state.rawOccupationUnavailabilities = data;
    },
    resetUnavailabilities (state) {
      state.rawOccupationUnavailabilities = {};
      state.rawUnavailabilities = {};
    },
  },
};
